import clsx from 'clsx';
import Link from 'next/link';
import { forwardRef } from 'react';

import { CharityCardDto } from '@/components/AboutUsPage/Charity/types';
import Image from '@/components/Image';
import { Typography } from '@/components/shared/Typography';
import cn from '@/helpers/cn';

import css from './style.module.scss';

interface Props {
	data: CharityCardDto;
	className?: string;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
}

const CharityCard = forwardRef<HTMLAnchorElement, Props>(
	({ data, onMouseEnter, onMouseLeave, className }, ref) => {
		const { href, cover, logo, text, title } = data;

		return (
			<Link
				ref={ref}
				className={clsx(css.card, className)}
				href={href}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
			>
				<Image className={css.logo} width={40} height={40} src={logo} alt={title} />

				<Typography uppercase variant="h4" tag="h3" className={cn(css.title, css.text)}>
					{title}
				</Typography>

				<Typography variant="body-l" tag="p" className={css.text}>
					{text}
				</Typography>

				<Image className={css.imageCover} width={350} height={250} src={cover} alt={title} />
			</Link>
		);
	}
);

export default CharityCard;
